import Cookies from 'js-cookie';

import { DatasourceService } from '@canvas/atlassian-service/datasource';
import { getServerIdFromCloudId } from '@canvas/atlassian-service/datasource/migration';

let cloudId: string | undefined;

let activationId: string | undefined;

export const setCloudId = (newCloudId: string | undefined) => {
  cloudId = newCloudId;
};

export const getCloudId = (): string | undefined => {
  if (cloudId) {
    return cloudId;
  }

  const queryParams = new URLSearchParams(window.location.search);
  return queryParams.get('cloudId') ?? undefined;
};

export const getBaseUrl = (): string => {
  let baseUrl = window.location.origin;
  if (new URL(baseUrl).hostname.includes('localhost')) {
    const backendOrigin = Cookies.get('BACKEND_ORIGIN');
    if (backendOrigin) {
      baseUrl = backendOrigin;
    }
  }
  return baseUrl + '/wiki';
};

export const setActivationId = (id: string | undefined) => {
  activationId = id;
};

export const getActivationId = (): string | undefined => {
  if (activationId) {
    return activationId;
  }

  const queryParams = new URLSearchParams(window.location.search);
  const id = queryParams.get('activationId') ?? undefined;
  if (id) {
    activationId = id;
  }

  return id;
};

export const getConfluenceWorkspaceId = (): string => {
  const cloudId = getCloudId();
  const activationId = getActivationId();

  return cloudId && activationId
    ? `ari:cloud:confluence:${cloudId}:workspace/${activationId}`
    : '';
};

export const getJiraServers = async () => {
  const sites = await new DatasourceService('jira').getAvailableSites();
  return await Promise.all(
    sites.map(async (site) => {
      const { name, cloudId } = site;
      const id = await getServerIdFromCloudId(cloudId);
      return { id, name, cloudId };
    })
  );
};
